/**
 * Specifies the File Manager internal ID's
 */
/** @hidden */
export var TOOLBAR_ID = '_toolbar';
/** @hidden */
export var LAYOUT_ID = '_layout';
/** @hidden */
export var NAVIGATION_ID = '_navigation';
/** @hidden */
export var TREE_ID = '_tree';
/** @hidden */
export var GRID_ID = '_grid';
/** @hidden */
export var LARGEICON_ID = '_largeicons';
/** @hidden */
export var DIALOG_ID = '_dialog';
/** @hidden */
export var ALT_DIALOG_ID = '_alt_dialog';
/** @hidden */
export var IMG_DIALOG_ID = '_img_dialog';
/** @hidden */
export var EXTN_DIALOG_ID = '_extn_dialog';
/** @hidden */
export var UPLOAD_DIALOG_ID = '_upload_dialog';
/** @hidden */
export var RETRY_DIALOG_ID = '_retry_dialog';
/** @hidden */
export var CONTEXT_MENU_ID = '_contextmenu';
/** @hidden */
export var SORTBY_ID = '_sortby';
/** @hidden */
export var VIEW_ID = '_view';
/** @hidden */
export var SPLITTER_ID = '_splitter';
/** @hidden */
export var CONTENT_ID = '_content';
/** @hidden */
export var BREADCRUMBBAR_ID = '_breadcrumbbar';
/** @hidden */
export var UPLOAD_ID = '_upload';
/** @hidden */
export var RETRY_ID = '_retry';
/** @hidden */
export var SEARCH_ID = '_search';
/**
 * Specifies the File Manager internal class names
 */
/** @hidden */
export var ROOT = 'e-filemanager';
/** @hidden */
export var CONTROL = 'e-control';
/** @hidden */
export var CHECK_SELECT = 'e-fe-cb-select';
/** @hidden */
export var ROOT_POPUP = 'e-fe-popup';
/** @hidden */
export var MOBILE = 'e-fe-mobile';
/** @hidden */
export var MOB_POPUP = 'e-fe-popup e-fe-mobile';
/** @hidden */
export var MULTI_SELECT = 'e-fe-m-select';
/** @hidden */
export var FILTER = 'e-fe-m-filter';
/** @hidden */
export var LAYOUT = 'e-layout';
/** @hidden */
export var NAVIGATION = 'e-navigation';
/** @hidden */
export var LAYOUT_CONTENT = 'e-layout-content';
/** @hidden */
export var LARGE_ICONS = 'e-large-icons';
/** @hidden */
export var TB_ITEM = 'e-toolbar-item';
/** @hidden */
export var LIST_ITEM = 'e-list-item';
/** @hidden */
export var LIST_TEXT = 'e-list-text';
/** @hidden */
export var LIST_PARENT = 'e-list-parent';
/** @hidden */
export var TB_OPTION_TICK = 'e-icons e-fe-tick';
/** @hidden */
export var TB_OPTION_DOT = 'e-icons e-fe-dot';
/** @hidden */
export var BLUR = 'e-blur';
/** @hidden */
export var ACTIVE = 'e-active';
/** @hidden */
export var HOVER = 'e-hover';
/** @hidden */
export var FOCUS = 'e-focus';
/** @hidden */
export var FOCUSED = 'e-focused';
/** @hidden */
export var CHECK = 'e-check';
/** @hidden */
export var FRAME = 'e-frame';
/** @hidden */
export var CB_WRAP = 'e-checkbox-wrapper';
/** @hidden */
export var ROW = 'e-row';
/** @hidden */
export var ROWCELL = 'e-rowcell';
/** @hidden */
export var EMPTY = 'e-empty';
/** @hidden */
export var EMPTY_CONTENT = 'e-empty-content';
/** @hidden */
export var EMPTY_INNER_CONTENT = 'e-empty-inner-content';
/** @hidden */
export var CLONE = 'e-fe-clone';
/** @hidden */
export var DROP_FOLDER = 'e-fe-drop-folder';
/** @hidden */
export var DROP_FILE = 'e-fe-drop-file';
/** @hidden */
export var FOLDER = 'e-fe-folder';
/** @hidden */
export var ICON_IMAGE = 'e-fe-image';
/** @hidden */
export var ICON_MUSIC = 'e-fe-music';
/** @hidden */
export var ICON_VIDEO = 'e-fe-video';
/** @hidden */
export var LARGE_ICON = 'e-large-icon';
/** @hidden */
export var LARGE_EMPTY_FOLDER = 'e-empty-icon e-fe-folder';
/** @hidden */
export var LARGE_EMPTY_FOLDER_TWO = 'e-empty-icon.e-fe-folder';
/** @hidden */
export var LARGE_ICON_FOLDER = 'e-fe-folder';
/** @hidden */
export var SELECTED_ITEMS = 'e-items';
/** @hidden */
export var TEXT_CONTENT = 'e-text-content';
/** @hidden */
export var GRID_HEADER = 'e-gridheader';
/** @hidden */
export var TEMPLATE_CELL = 'e-templatecell';
/** @hidden */
export var TREE_VIEW = 'e-treeview';
/** @hidden */
export var MENU_ITEM = 'e-menu-item';
/** @hidden */
export var MENU_ICON = 'e-menu-icon';
/** @hidden */
export var SUBMENU_ICON = 'e-caret';
/** @hidden */
export var GRID_VIEW = 'e-content';
/** @hidden */
export var GRID_CONTENT = 'e-gridcontent';
/** @hidden */
export var ICON_VIEW = 'e-list-parent';
/** @hidden */
export var ICON_OPEN = 'e-icons e-fe-open';
/** @hidden */
export var ICON_UPLOAD = 'e-icons e-fe-upload';
/** @hidden */
export var ICON_CUT = 'e-icons e-fe-cut';
/** @hidden */
export var ICON_COPY = 'e-icons e-fe-copy';
/** @hidden */
export var ICON_PASTE = 'e-icons e-fe-paste';
/** @hidden */
export var ICON_DELETE = 'e-icons e-fe-delete';
/** @hidden */
export var ICON_RENAME = 'e-icons e-fe-rename';
/** @hidden */
export var ICON_NEWFOLDER = 'e-icons e-fe-newfolder';
/** @hidden */
export var ICON_DETAILS = 'e-icons e-fe-details';
/** @hidden */
export var ICON_SHORTBY = 'e-icons e-fe-sort';
/** @hidden */
export var ICON_REFRESH = 'e-icons e-fe-refresh';
/** @hidden */
export var ICON_SELECTALL = 'e-icons e-fe-select';
/** @hidden */
export var ICON_DOWNLOAD = 'e-icons e-fe-download';
/** @hidden */
export var ICON_OPTIONS = 'e-icons e-fe-options';
/** @hidden */
export var ICON_GRID = 'e-icons e-fe-grid';
/** @hidden */
export var ICON_LARGE = 'e-icons e-fe-large';
/** @hidden */
export var ICON_FOLDER = 'e-icons e-folder';
/** @hidden */
export var ICON_FILE = 'e-icons e-file-format';
/** @hidden */
export var ICON_BREADCRUMB = 'e-icons e-fe-breadcrumb';
/** @hidden */
export var ICON_CLEAR = 'e-icons e-fe-clear';
/** @hidden */
export var ICON_DROP_IN = 'e-icons e-fe-drop-in';
/** @hidden */
export var ICON_DROP_OUT = 'e-icons e-fe-drop-out';
/** @hidden */
export var ICON_NO_DROP = 'e-icons e-fe-no-drop';
/** @hidden */
export var ICONS = 'e-icons';
/** @hidden */
export var DETAILS_LABEL = 'e-detailslabel';
/** @hidden */
export var ERROR_CONTENT = 'e-fe-errorcontent';
/** @hidden */
export var STATUS = 'e-status';
/** @hidden */
export var BREADCRUMBS = 'e-address';
/** @hidden */
export var RTL = 'e-rtl';
/** @hidden */
export var DISPLAY_NONE = 'e-display-none';
/** @hidden */
export var COLLAPSED = 'e-node-collapsed';
/** @hidden */
export var FULLROW = 'e-fullrow';
/** @hidden */
export var ICON_COLLAPSIBLE = 'e-icon-collapsible';
/** @hidden */
export var SPLIT_BAR = 'e-split-bar';
/** @hidden */
export var HEADER_CHECK = 'e-headercheck';
/** @hidden */
export var OVERLAY = 'e-fe-overlay';
/** @hidden */
export var VALUE = 'e-fe-value';
